import TimezoneResolver from "shared/timezone_resolver"
import UserEventsTracker from "shared/user_events_tracker"
import { init, GlobalHandlers } from "@sentry/react"
import { ExtraErrorData } from "@sentry/integrations"

import purify from "dompurify"

import * as $ from "jquery"

export function oneTimeSetup() {
  window.uiEventTracker = new UserEventsTracker()

  $(document).on("ajax:success", "*[data-flash-success]", function () {
    window.appendFlash($(this).data("flash-success"))
  })

  $(document).on("ajax:error", "*[data-flash-error]", function () {
    window.appendFlash($(this).data("flash-error"), "danger")
  })

  $(document).on(
    "click",
    "header.unified-header.signed-in a[data-intercept-mobile-users]",
    function (evt) {
      evt.preventDefault()
      const paymentType = $(this).data("intercept-mobile-users")

      if (paymentType === "apple") {
        window.appendFlash(
          "You currently have a Pro subscription on Apple. Please upgrade to Pro+ on your iOS device.",
          "danger"
        )
      } else if (paymentType === "google") {
        window.appendFlash(
          "You currently have a Pro subscription on Google. Please upgrade to Pro+ on your Android device.",
          "danger"
        )
      }
    }
  )

  TimezoneResolver()
}

export function newrelicSetup() {
  // Tell NewRelic to ignore specific JS errors that we can't fix or control for,
  // primarily browser and browser extension related.
  if (window.App && typeof newrelic !== "undefined") {
    newrelic.setErrorHandler(function (err) {
      // Test ignoring all to reduce the number of new relic agent error logging requests
      return true
    })
  }
}

export function sharedSetup() {
  window.appendFlash = function (message, type = "success", callback) {
    let msg = $(
      `<div class="flash-msg alert alert-${type}">${purify.sanitize(
        message
      )}</div>`
    )
    $("#flash-messages, #ifttt-next-flash-messages").append(msg)
    msg.hide().fadeIn(500)
    setTimeout(() => msg.fadeOut(callback), 3000)
  }

  if ($(".flash-msg").not(".sticky").length > 0) {
    setInterval(function () {
      $(".flash-msg").not(".sticky").fadeOut()
    }, 3000)
  }

  // Web isn't using experiments for now. Reducing unnecessary calls until we
  // move Experiments to Graph and reimplement the solution.
  // confirmExperimentReceipts()

  // Enable JS error reporting via Sentry
  if (window.App && window.App.sentryDSNGrizzlyClient) {
    init({
      dsn: window.App.sentryDSNGrizzlyClient,
      // With this integration, Sentry will inject enumerable error properties
      // for every JS Object that errs, including non-Error ones.
      integrations: [
        // Most Promise libraries have a global hook for capturing unhandled errors.
        // As we don't have control over what third-party libraries use, we'll
        // turn this kind of error off.
        new GlobalHandlers({ onunhandledrejection: false }),
        new ExtraErrorData(),
      ],
      ignoreErrors: [
        "YsAppBridge is not defined", // Ignored as part of legacy page that causes wierd errors: https://ifttt-dev.atlassian.net/browse/OC-1420
        "MtPopUpList is not defined",
        "GEOCODER_GEOCODE: ZERO_RESULTS", // Difficult-to-catch error from Google Geocoder API
      ],
    })
  }

  window.uiEventTracker.domReadySetup()
}
